import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=c56f397a&scoped=true&"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordModal.vue?vue&type=style&index=0&id=c56f397a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f397a",
  null
  
)

export default component.exports